import actionConsts from "./../../constants/actions";

const calls = (state = [], action = {}) => {
	const { payload } = action;
	switch (action.type) {
		case actionConsts.RECEIVE_INIT_DATA:
			let tutorialData = payload.tutorial.tutorialData;
			return [
				...state,
				...tutorialData.mails.filter(mail => {
					return mail.type === "call";
				})
			];

		case actionConsts.SET_MAILS:
			return [
				...payload.mails.filter(mail => {
					return mail.type === "call";
				})
			];

		case actionConsts.RESTART_TUTORIAL:
			return payload.mails.filter(mail => {
				return mail.type === "call";
			});

		case actionConsts.START_CALL:
			return state.map(call => {
				if (call.id === payload) {
					return {
						...call,
						actionThread: [
							...call.actionThread,
							{
								type: "call_started",
								status: "true"
							}
						]
					};
				}
				return call;
			});

		case actionConsts.TERMINATE_CALL:
			return state.map(call => {
				if (call.id === payload) {
					return {
						...call,
						actionThread: [
							...call.actionThread,
							{
								type: "call_terminated",
								status: "true"
							}
						]
					};
				}
				return call;
			});

		// case actionConsts.ADD_SHOW_CALL_FLAG:
		//     return state.map(call => {
		//         if (call.id === payload.call.id) {
		//             return {
		//                 ...call,
		//                 receivedAtTime: payload.expectedAtTime
		//             }
		//         }
		//         return call
		//     })
		default:
			return state;
	}
};

export default calls;



// WEBPACK FOOTER //
// /src/reducers/call/index.js